import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/despesas?status=${filtro.status != null ? filtro.status : ''}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFiltros() {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/despesas/filtros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/despesas/${despesaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometer(despesaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/finalizacao/despesas/${despesaId}/comprometer`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/despesas/${despesaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimento(etapaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/finalizacao/despesas/${etapaId}/excluircomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ajustarBoleto(despesaBoletoDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/finalizacao/despesas/${despesaBoletoDto.despesaId}/ajustarboleto`, despesaBoletoDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/despesas/${despesaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/despesas/${despesaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    reprovar(despesaId, justificativaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/finalizacao/despesas/${despesaId}/reprovar`, justificativaDto)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    cancelar(despesaId, justificativaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/finalizacao/despesas/${despesaId}/cancelar`, justificativaDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}